import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

// Renders an <img>, but swaps to a text placeholder if the image fails to load.
// - Bad / missing URL (404, malformed, CORS, etc.): "Image not found"
// - Client appears offline when the error fires:      "Failed to load image"
const MenuImage = ({ src, alt, className, style }) => {
    const [errorType, setErrorType] = useState(null); // null | 'offline' | 'notfound'

    // Reset error state whenever the src changes so a new URL gets a fresh attempt.
    useEffect(() => {
        setErrorType(null);
    }, [src]);

    const handleError = () => {
        if (typeof navigator !== "undefined" && navigator.onLine === false) {
            setErrorType("offline");
        } else {
            setErrorType("notfound");
        }
    };

    if (errorType) {
        const message =
            errorType === "offline" ? "Failed to load image" : "Image not found";
        return (
            <Box
                className={className}
                style={style}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.35)",
                    padding: "8px",
                    boxSizing: "border-box",
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "Inter !important",
                        fontSize: "12px !important",
                        fontWeight: "500 !important",
                        color: "#fff",
                        textAlign: "center",
                        textShadow:
                            `0 0 2px rgba(0,0,0,0.8),
                            1px 1px 2px rgba(0,0,0,0.8),
                            -1px -1px 2px rgba(0,0,0,0.8),
                            1px -1px 2px rgba(0,0,0,0.8),
                            -1px 1px 2px rgba(0,0,0,0.8)`
                    }}
                >
                    {message}
                </Typography>
            </Box >
        );
    }

    return (
        <img
            src={src}
            alt={alt}
            className={className}
            style={style}
            onError={handleError}
        />
    );
};

export default MenuImage;
